const GET_FORM_VALUES = 'publicador/step1Module4/GET_FORM_VALUES';
export { GET_FORM_VALUES };
